// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__qOnTL","bigColWidth":"Table_bigColWidth__qPWem","biggerColWidth":"Table_biggerColWidth__XN8Kl","row":"Table_row__3J1KR","col":"Table_col__uudop"};